var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "scrollable": "",
      "width": "600"
    },
    model: {
      value: _vm.dialog,
      callback: function callback($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v(" " + _vm._s(_vm.allowTranslationsEdit ? _vm.$t('translations_edit_languages') : _vm.$t('translations_change_reference_language')) + " ")]), _c('v-card-text', [_c('div', {
    staticClass: "font-weight-bold mt-4"
  }, [_vm._v(" " + _vm._s(_vm.$t('translations_current_reference_language')) + " ")]), _c('div', [_vm._v(" " + _vm._s(_vm.$t('languages_' + _vm.defaultLanguage)) + " ")]), _c('div', {
    staticClass: "font-weight-bold mt-4"
  }, [_vm._v(" " + _vm._s(_vm.$t('translations_new_reference_language')) + " ")]), _c('div', {
    staticClass: "mb-3"
  }, [_vm._v(" " + _vm._s(_vm.$t('translations_reference_language_hint')) + " ")]), _c('v-autocomplete', {
    staticClass: "mt-2",
    attrs: {
      "items": _vm.availableDefaultLanguages,
      "item-value": "key",
      "item-text": "name",
      "label": _vm.$t('translations_select_reference_language'),
      "no-data-text": _vm.availableDefaultLanguages.length === 0 ? _vm.$t('translations_reference_language_empty_hint') : _vm.$t('no_match_found'),
      "solo": ""
    },
    model: {
      value: _vm.newDefaultLanguage,
      callback: function callback($$v) {
        _vm.newDefaultLanguage = $$v;
      },
      expression: "newDefaultLanguage"
    }
  }), _vm.allowTranslationsEdit ? _c('div', [_c('div', {
    staticClass: "font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.$t('translations')) + " ")]), _c('v-autocomplete', {
    staticClass: "my-3",
    attrs: {
      "items": _vm.allLanguagesDropdown,
      "search-input": _vm.allLanguagesSearchInput,
      "item-text": "name",
      "item-value": "key",
      "chips": "",
      "label": _vm.$t('select_languages'),
      "placeholder": "Search for a language",
      "multiple": ""
    },
    on: {
      "update:searchInput": function updateSearchInput($event) {
        _vm.allLanguagesSearchInput = $event;
      },
      "update:search-input": function updateSearchInput($event) {
        _vm.allLanguagesSearchInput = $event;
      },
      "change": function change($event) {
        _vm.allLanguagesSearchInput = '';
      }
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function fn(data) {
        return [_c('v-chip', _vm._b({
          attrs: {
            "input-value": data.selected,
            "close": ""
          },
          on: {
            "click": data.select,
            "click:close": function clickClose($event) {
              return _vm.removeSelectedTranslationLanguage(data.item);
            }
          }
        }, 'v-chip', data.attrs, false), [_vm._v(" " + _vm._s(data.item.name) + " ")])];
      }
    }], null, false, 2974339869),
    model: {
      value: _vm.selectedTranslationLanguages,
      callback: function callback($$v) {
        _vm.selectedTranslationLanguages = $$v;
      },
      expression: "selectedTranslationLanguages"
    }
  })], 1) : _vm._e()], 1), _c('v-card-actions', [_vm.showGoToTranslations ? _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": _vm.goToTranslations
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('go_to_translations')) + " ")]) : _vm._e(), _c('v-spacer'), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": _vm.closeDialog
    }
  }, [_vm._v(_vm._s(_vm.$t('close')))]), _c('v-btn', {
    staticClass: "btn-text-white",
    attrs: {
      "raised": "",
      "color": "primary"
    },
    on: {
      "click": _vm.saveLanguagesEdit
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('save')) + " ")])], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }